// Adapted from: https://www.w3.org/TR/wai-aria-practices-1.1/examples/accordion/js/accordion.js

export default class Accordion {

    constructor() {
        window.addEventListener('DOMContentLoaded', () => {
            this.init();
        });
    }

    init() {
        /*
         *   This content is licensed according to the W3C Software License at
         *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
         *
         *   Simple accordion pattern example
         */

        'use strict';

        Array.prototype.slice.call(document.querySelectorAll('.accordion')).forEach(function(accordion) {

            // Allow for multiple accordion sections to be expanded at the same time
            var allowMultiple = accordion.hasAttribute('data-allow-multiple');
            // Allow for each toggle to both open and close individually
            var allowToggle = (allowMultiple) ? allowMultiple : accordion.hasAttribute('data-allow-toggle');

            var allowKeyboard = accordion.hasAttribute('data-allow-keyboard');

            // Create the array of toggle elements for the accordion group
            var triggers = Array.prototype.slice.call(accordion.querySelectorAll('.accordion__trigger'));
            var panels = Array.prototype.slice.call(accordion.querySelectorAll('.accordion__panel'));


            accordion.addEventListener('click', function(event) {
                var target = event.target;

                // if (target.classList.contains('accordion__item') || target.classList.contains('accordion__items')) {

                //     let sections = document.querySelectorAll('accordion__section');
                //     sections.forEach((item) => {
                //         item.classList.remove('category-focused');
                //     });

                //     let thisCat = target.closest('.accordion__section');
                //     thisCat.classList.add('category-focused');
                // }

                if (target.classList.contains('accordion__trigger')) {
                    // Check if the current toggle is expanded.
                    var isExpanded = target.getAttribute('aria-expanded') == 'true';

                    var parent = document.getElementById(target.getAttribute('data-parent'));

                    var active = accordion.querySelector('[aria-expanded="true"]');

                    if (target.classList.contains('accordion__child')) {

                        // console.log(parent, active);

                        if (parent == active) {
                            active = parent.querySelector('[aria-expanded="true"]');
                        }
                    }

                    // without allowMultiple, close the open accordion
                    if (!allowMultiple && active && active !== target) {
                        // Scan all active accordions
                        var allActive = accordion.querySelectorAll('[aria-expanded="true"]');
                        allActive.forEach(function(active) {
                            // Set the expanded state on the triggering element
                            active.setAttribute('aria-expanded', 'false');

                            // setTimeout(function() {

                            // }, 100);

                            // close the active element
                            var activeParent = document.getElementById(active.getAttribute('data-parent'));
                            activeParent.classList.remove('category-open');
                            activeParent.classList.remove('subcategory-open');

                            // Hide the accordion sections, using aria-controls to specify the desired section
                            document.getElementById(active.getAttribute('aria-controls')).setAttribute('hidden', '');

                            // When toggling is not allowed, clean up disabled state
                            if (!allowToggle) {
                                active.removeAttribute('aria-disabled');
                            }
                        });
                    }

                    if (!isExpanded) {
                        // Set the expanded state on the triggering element
                        target.setAttribute('aria-expanded', 'true');
                        // Hide the accordion sections, using aria-controls to specify the desired section
                        document.getElementById(target.getAttribute('aria-controls')).removeAttribute('hidden');

                        // If toggling is not allowed, set disabled state on trigger
                        if (!allowToggle) {
                            target.setAttribute('aria-disabled', 'true');
                        }

                        if (target.classList.contains('accordion__child')) {
                            parent.classList.add('subcategory-open');
                        } else {
                            parent.classList.add('category-open');

                            // Get reference to all child accordion triggers
                            let parentId = target.getAttribute('data-parent');
                            let childSelector = ".accordion__child[data-parent=\"" + parentId + "\"]";
                            let children = document.querySelectorAll(childSelector);

                            // Make all child accordions selectable in the tabindex now that they are visible
                            children.forEach((item) => {
                                item.setAttribute('tabindex', '0');
                            });
                        }

                        // // console.log(target);
                        // setTimeout(function() {
                        //     var h = target.offsetTop - 24;

                        //     // console.log(h);

                        //     window.scroll({
                        //         top: h,
                        //         left: 0,
                        //         behavior: 'smooth'
                        //     });
                        // }, 100);

                    } else if (allowToggle && isExpanded) {
                        // Set the expanded state on the triggering element
                        target.setAttribute('aria-expanded', 'false');
                        // Hide the accordion sections, using aria-controls to specify the desired section
                        document.getElementById(target.getAttribute('aria-controls')).setAttribute('hidden', '');

                        if (target.classList.contains('accordion__child')) {
                            parent.classList.remove('subcategory-open');
                        } else {
                            parent.classList.remove('category-open');
                            parent.classList.remove('subcategory-open');

                            // Get reference to all child accordion triggers
                            let parentId = target.getAttribute('data-parent');
                            let childSelector = ".accordion__child[data-parent=\"" + parentId + "\"]";
                            let children = document.querySelectorAll(childSelector);

                            children.forEach((item) => {
                                item.setAttribute('tabindex', '-1');
                            });
                        }
                    }

                    event.preventDefault();
                    event.stopPropagation();
                }
            });

            if (allowKeyboard) {
                // Bind keyboard behaviors on the main accordion container
                accordion.addEventListener('keydown', function(event) {
                    var target = event.target;
                    var key = event.which.toString();

                    var isExpanded = target.getAttribute('aria-expanded') == 'true';
                    var allowToggle = (allowMultiple) ? allowMultiple : accordion.hasAttribute('data-allow-toggle');

                    let visible_triggers = Array.prototype.slice.call(accordion.querySelectorAll('.accordion__section > .accordion__trigger'));

                    // 33 = Page Up, 34 = Page Down
                    var ctrlModifier = (event.ctrlKey && key.match(/33|34/));

                    // Is this coming from an accordion header?
                    if (target.classList.contains('accordion__trigger')) {
                        // Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
                        // 38 = Up, 40 = Down
                        if (key.match(/38|40/) || ctrlModifier) {
                            var index = visible_triggers.indexOf(target);
                            var direction = (key.match(/34|40/)) ? 1 : -1;
                            var length = visible_triggers.length;

                            // var newIndex = (index + length + direction) % length;
                            var newIndex = index + direction;

                            if (newIndex < 0) { newIndex = visible_triggers.length - 1; }
                            if (newIndex >= visible_triggers.length) { newIndex = 0; }

                            console.log("Index: " + index, "Direction: " + direction, "Length: " + length, "NewIndex: " + newIndex);

                            visible_triggers[newIndex].focus();

                            event.preventDefault();
                        } else if (key.match(/35|36/)) {
                            // 35 = End, 36 = Home keyboard operations
                            switch (key) {
                                // Go to first accordion
                                case '36':
                                    visible_triggers[0].focus();
                                    break;
                                    // Go to last accordion
                                case '35':
                                    visible_triggers[visible_triggers.length - 1].focus();
                                    break;
                            }
                            event.preventDefault();
                        }
                    }
                });
            }


            // These are used to style the accordion when one of the buttons has focus
            accordion.querySelectorAll('.accordion__trigger').forEach(function(trigger) {

                trigger.addEventListener('focus', function(event) {
                    let parent = document.getElementById(trigger.getAttribute('data-parent'));
                    accordion.classList.add('focus');
                    parent.classList.add('category-focused');
                });

                trigger.addEventListener('blur', function(event) {
                    let parent = document.getElementById(trigger.getAttribute('data-parent'));
                    accordion.classList.remove('focus');
                    parent.classList.remove('category-focused');
                });

            });

            // Minor setup: will set disabled state, via aria-disabled, to an
            // expanded/ active accordion which is not allowed to be toggled close
            if (!allowToggle) {
                // Get the first expanded/ active accordion
                var expanded = accordion.querySelector('[aria-expanded="true"]');

                // If an expanded/ active accordion is found, disable
                if (expanded) {
                    expanded.setAttribute('aria-disabled', 'true');
                }
            }

        });
    }
}